/*****************************************************************************
 * UmanIT - Additionnal info on tabs (product page)
 * Set tabs size
 *****************************************************************************/


const containerToResize = document.querySelector("[data-resize='setsize']");
const headings = Array.from(document.querySelectorAll("[data-getsize='heading']"));
const contents = Array.from(document.querySelectorAll("[data-getsize='content']"));
let headingHeight = 0;
let contentHeight = 0;
const paddingValue = 40; // 40 étant la valeur x 2 du padding top du titre, pour décaler l'affichage d'autant


if(breakpoints.isDesktop()) {
  headingHeight = getMaxHeight(headings, headingHeight);
  contentHeight = getMaxHeight(contents, contentHeight);

  headings.forEach((heading) => heading.style.height = headingHeight+"px");

  const totalHeight = headingHeight + contentHeight;
  containerToResize.style.minHeight = totalHeight+"px";
  containerToResize.style.top = paddingValue+"px";
} else {
  containerToResize.style.minHeight = "initial";
  containerToResize.style.top = "initial";
}

window.addEventListener("resize", function() {
  setTimeout(function() {
    if(breakpoints.isDesktop()) {
      headingHeight = getMaxHeight(headings, headingHeight);
      contentHeight = getMaxHeight(contents, contentHeight);

      headings.forEach((heading) => heading.style.height = headingHeight+"px");

      const totalHeight = headingHeight + contentHeight;
      containerToResize.style.minHeight = totalHeight+paddingValue+"px";
      containerToResize.style.top = paddingValue+"px";
    } else {
      containerToResize.style.minHeight = "initial";
      containerToResize.style.top = "initial";
    }
  }, 200);
});

/**
 * Fonction qui boucle les éléments pour récupérer la plus grande taille de la série
 *
 * return {maxHeight}
 */
function getMaxHeight(items, heightValue) {
  items.forEach(function(item) {
    const itemCoords = item.getBoundingClientRect();


    const itemHeight = itemCoords.height;

    if(itemHeight > heightValue) {
      heightValue = itemHeight;
    }
  });
  return heightValue;
}
